import { jsxs, jsx } from 'react/jsx-runtime';
import { c as classNames } from '../theme-provider/index-chunk.esm.js';
import { a as EGDSIcon, E as EGDSIconSize } from '../icon/index-chunk.esm.js';
import styles from '../styles/uitk-egds-step-indicator.css';
import 'react';
import '../styles/uitk-egds-utils.css';
import '../styles/uitk-egds-foundation.css';
import '@shared-ui/brand-context';
import '@shared-ui/experiment-context';
import '../styles/uitk-egds-icons.css';
import '../validate-prop-types/index-chunk.esm.js';

const getClassNameList$1 = classNames.bind(styles);
const StepIndicatorItem = (props) => {
    const { active, complete, content, direction, hasLeadingAndTrailingLines, icon, isDecorativeOnly, label, labelSize, stepIndicatorSize, } = props;
    const stepperContentClass = getClassNameList$1('step-indicator-stepper-content');
    const stepperClass = 'step-indicator-stepper';
    const stepperClasses = getClassNameList$1(stepperClass, {
        [`${stepperClass}-size-${stepIndicatorSize}`]: stepIndicatorSize,
        [`${stepperClass}-direction-${direction}`]: direction,
        [`${stepperClass}-complete`]: !isDecorativeOnly && complete,
        [`${stepperClass}-active`]: !isDecorativeOnly && active,
        [`${stepperClass}-has-leading-and-trailing`]: isDecorativeOnly && direction === 'horizontal' && hasLeadingAndTrailingLines,
    });
    const stepperMarkerClass = 'step-indicator-stepper-marker';
    const stepperMarkerClasses = getClassNameList$1(stepperMarkerClass);
    const markerCircleClass = 'step-indicator-stepper-marker-circle';
    const markerCircleClasses = getClassNameList$1(markerCircleClass, {
        [`${markerCircleClass}-size-${stepIndicatorSize}`]: stepIndicatorSize,
        [`${markerCircleClass}-has-icon`]: !isDecorativeOnly && icon,
    });
    const labelClass = 'step-indicator-stepper-label';
    const labelClasses = getClassNameList$1(labelClass, {
        [`${labelClass}-${labelSize}`]: labelSize,
    });
    return (jsxs("li", { className: stepperClasses, children: [jsx("div", { className: stepperMarkerClasses, children: jsx("div", { className: markerCircleClasses, children: icon && stepIndicatorSize === 'large' && jsx(EGDSIcon, { name: icon, size: EGDSIconSize.EXTRA_SMALL }) }) }), (label || content) && (jsxs("div", { className: stepperContentClass, children: [label && jsx("label", { className: labelClasses, children: label }), content && jsx("div", { children: content })] }))] }));
};

const getClassNameList = classNames.bind(styles);
const StepIndicator = (props) => {
    const { activeStep, direction, hasLeadingAndTrailingLines, isDecorativeOnly, labelSize, stepIndicatorSize, steps, stepLength, } = props;
    const stepStyle = isDecorativeOnly ? 'decorative' : stepIndicatorSize;
    const stepIndicatorClass = 'step-indicator';
    const stepIndicatorClasses = getClassNameList(stepIndicatorClass, {
        [`${stepIndicatorClass}-direction-${direction}`]: direction,
        [`${stepIndicatorClass}-step-length-${stepLength}`]: stepLength,
    });
    return (jsx("ol", { className: stepIndicatorClasses, children: steps?.map((step, index) => {
            const active = activeStep === index + 1;
            const complete = index + 1 < activeStep;
            return (jsx(StepIndicatorItem, { content: step.content, icon: step.icon, label: step.label, active: active, complete: complete, direction: direction, hasLeadingAndTrailingLines: hasLeadingAndTrailingLines, isDecorativeOnly: isDecorativeOnly, labelSize: labelSize, stepIndicatorSize: stepStyle }, `step-${index}`));
        }) }));
};
StepIndicator.defaultProps = {
    direction: 'horizontal',
    stepIndicatorSize: 'small',
    stepLength: 'equal',
    hasLeadingAndTrailingLines: false,
    isDecorativeOnly: false,
    labelSize: 'medium',
};

export { StepIndicator, StepIndicatorItem };
//# sourceMappingURL=index.esm.js.map
